<template>
    <div class="card form-card">
        <div class="card-header bg-primary text-white text-center py-2">
            <h3 class="mb-0 fs-5">Formularz Rejestracji na Turniej</h3>
        </div>
        <div class="card-body p-3">

            <!-- Powiadomienia sukcesu i błędów (zostają bez zmian) -->
            <div v-if="successMessage" class="alert alert-success alert-dismissible fade show py-2" role="alert">
                {{ successMessage }}
                <button type="button" class="btn-close py-2.5" @click="successMessage = ''"></button>
            </div>
            <div v-if="errors.length > 0" class="alert alert-danger alert-dismissible fade show py-2" role="alert">
                <ul class="mb-0 small"><li v-for="(error, index) in errors" :key="index">{{ error }}</li></ul>
                <button type="button" class="btn-close py-2.5" @click="errors = []"></button>
            </div>

            <form @submit.prevent="submitForm">
                
                <!-- RZĄD 1: Imię i nazwisko + Płeć (bez zmian) -->
                <div class="row g-2 g-sm-3 mb-3">
                    <div class="col-sm-7 col-md-8">
                        <label for="name" class="form-label mb-1 small fw-bold">Imię i Nazwisko <span class="text-danger">*</span></label>
                        <input type="text" id="name" v-model="form.name" @input="validateNameInput" class="form-control" placeholder="Jan Kowalski" required>
                    </div>
                    <div class="col-sm-5 col-md-4">
                        <label class="form-label d-block mb-1 small fw-bold">Płeć <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center" style="height: 38px;">
                            <div class="form-check me-2 me-sm-3">
                                <input type="radio" id="gender_male" v-model="form.gender" value="male" class="form-check-input" required>
                                <label class="form-check-label small" for="gender_male">Mężczyzna</label>
                            </div>
                            <div class="form-check">
                                <input type="radio" id="gender_female" v-model="form.gender" value="female" class="form-check-input" required>
                                <label class="form-check-label small" for="gender_female">Kobieta</label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- RZĄD 2: Kategoria + v-select godzin (Z CAŁKOWITYM LIMITU MIEJSC) -->
                <div class="row g-2 g-sm-3 mb-3">
                    <div class="col-sm-6">
                        <label for="category_id" class="form-label mb-1 small fw-bold">Kategoria <span class="text-danger">*</span></label>
                        <select id="category_id" v-model="form.category_id" class="form-select" required>
                            <option value="">-- Wybierz kategorię --</option>
                            <option v-for="category in categories" :key="category.id" :value="category.id">
                                {{ category.name }}
                            </option>
                        </select>
                    </div>
                    
                    <div class="col-sm-6 position-relative">
                        <label class="form-label mb-1 small fw-bold">Godzina startu <span class="text-danger">*</span></label>
                        
                        <div class="form-select custom-v-select d-flex justify-content-between align-items-center" @click="dropdownOpen = !dropdownOpen">
                            <span v-if="!form.slot_id" class="text-muted small">-- Wybierz godzinę --</span>
                            <span v-else class="fw-bold text-primary">{{ selectedSlotText }}</span>
                        </div>

                        <!-- Dropdown ze stanem ogólnych wolnych miejsc na kręgielni -->
                        <div v-if="dropdownOpen" class="custom-v-dropdown shadow-sm border">
                            <div 
                                v-for="slot in slotsList" 
                                :key="slot.id" 
                                class="dropdown-option d-flex justify-content-between align-items-center p-2 border-bottom"
                                @click="selectSlot(slot)" :class="(slot.total_capacity - slot.registrations_count === 0) ? 'dropdown-option-disabled' : ''"
                            >
                                <span class="fw-bold text-dark">{{ slot.time_string }}</span>
                                
                                <span :class="getSlotBadgeClass(slot)">
                                    {{ slot.total_capacity - slot.registrations_count }} wolnych miejsc
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

  
                <div class="alert alert-info py-1 px-3 mb-3 text-center"><small>Wymagane jest podanie e-mail <b>lub</b> telefonu.</small></div>
                <div class="row g-2 g-sm-3 mb-2">
                    <div class="col-md-6">
                        <label for="email" class="form-label mb-1 small fw-bold">Adres E-mail</label>
                        <input type="email" id="email" v-model="form.form_email" class="form-control" placeholder="przyklad@domena.pl" :required="!form.phone_no">
                    </div>
                    <div class="col-md-6">
                        <label for="phone_no" class="form-label mb-1 small fw-bold">Numer telefonu</label>
                        <input type="text" id="phone_no" v-model="form.phone_no" @input="validatePhoneInput" maxlength="9" placeholder="123456789" class="form-control" :required="!form.form_email">
                    </div>
                </div>


                <div class="mb-3 form-check text-start">
                    <input 
                        type="checkbox" 
                        id="rules_accepted" 
                        v-model="form.rules_accepted" 
                        class="form-check-input" 
                        required
                    >
                    <label class="form-check-label small text-dark" for="rules_accepted">
                        Oświadczam, że akceptuję 
                        <a href="/regulamin.pdf" target="_blank" class="fw-bold text-primary text-decoration-none">
                            Regulamin Turnieju
                        </a> 
                        oraz zasady gry na kręgielni. <span class="text-danger">*</span>
                    </label>
                </div>                

                <button type="submit" class="btn btn-primary w-100 btn-md mt-3" :disabled="loading">Zapisz się na turniej</button>

                <div class="text-center mt-3 text-muted small">
                    Aktualna liczba zapisanych uczestników: <span class="badge bg-danger px-2 py-1 fs-6">{{ currentTotalCount }}</span>
                </div>

                <!-- PRZYWRÓCONA TABELA DARMOWYCH BILETÓW PER KATEGORIA -->
                <!-- <div class="mt-4 pt-3 border-top" v-if="form.slot_id">  -->
                <div class="mt-4 pt-3 border-top" >
                    <h5 class="text-center text-secondary mb-2 small fw-bold text-uppercase" style="letter-spacing: 1px;">
                        🎁 Dostępność darmowych wejściówek dla godziny {{ selectedSlotTimeOnly }} 🎁
                    </h5>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered text-center mb-0 bg-white" style="font-size: 0.85rem;">
                            <thead class="table-light">
                                <tr>
                                    <th class="text-start ps-2">Kategoria</th>
                                    <th>Darmowe miejsca</th>
                                    <th>Status puli</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="category in categories" :key="category.id">
                                    <td class="fw-bold text-start ps-2">{{ category.name }}</td>
                                    <td>
                                        <span v-if="getPoolForCategoryAndSlot(category.id) && getPoolForCategoryAndSlot(category.id).total_slots === 0" class="text-muted" >
                                            -
                                        </span>
                                        <span v-else-if="getPoolForCategoryAndSlot(category.id)">
                                            <strong>{{ getPoolForCategoryAndSlot(category.id).remaining_slots }}</strong> / {{ getPoolForCategoryAndSlot(category.id).total_slots }}
                                        </span>
                                        <span v-else class="text-muted">-</span>
                                    </td>
                                    <td>
                                        <span v-if="!getPoolForCategoryAndSlot(category.id)" class="badge bg-secondary">Standard</span>
                                        <span v-else-if="getPoolForCategoryAndSlot(category.id).total_slots === 0" class="badge bg-secondary">Standard</span>
                                        <span v-else-if="getPoolForCategoryAndSlot(category.id).remaining_slots > 0" class="badge bg-success">Dostępna</span>
                                        <span v-else class="badge bg-danger">Koniec puli</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div v-if="showPaidModal" class="modal fade show d-block animate-fade-in" tabindex="-1" style="background: rgba(0,0,0,0.5); z-index: 1060;">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content border-0 shadow-lg">
                            <div class="modal-header bg-warning text-dark py-2">
                                <h5 class="modal-title fs-6 fw-bold">⚠️ Wymagane potwierdzenie</h5>
                            </div>
                            <div class="modal-body py-3 text-center">
                                <p class="mb-0 fw-bold text-dark" style="font-size: 0.95rem;">
                                    W Twojej kategorii nie było lub wyczerpała się pula darmowych zapisów.<br>
                                    <span class="text-danger">Zapisujesz się na miejsce płatne! Opłata za grę wynosi: 30 PLN</span>
                                </p>
                            </div>
                            <div class="modal-footer d-flex justify-content-between py-2 bg-light">
                                <button type="button" class="btn btn-sm btn-secondary fw-bold" @click="cancelPaidRegistration">
                                    Nie zapisuj
                                </button>
                                <button 
                                    type="button" 
                                    class="btn btn-sm btn-danger fw-bold px-3" 
                                    :disabled="countdown > 0 || loading"
                                    @click="confirmPaidRegistration"
                                >
                                    <span v-if="countdown > 0">Mimo to zapisz ({{ countdown }}s)</span>
                                    <span v-else>Mimo to zapisz</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                


                <div v-if="showSuccessInfoModal" class="modal fade show d-block animate-fade-in" tabindex="-1" style="background: rgba(0,0,0,0.5); z-index: 1060;">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content border-0 shadow-lg">
                            <div class="modal-header bg-light text-dark py-2 border-bottom">
                                <h5 class="modal-title fs-6 fw-bold">ℹ️ Informacja</h5>
                            </div>
                            <div class="modal-body py-4 text-center">
                                <p class="mb-0 text-muted" style="font-size: 0.95rem; line-height: 1.5;">
                                    Dziękujemy za zapisanie się na wydarzenie. Na podany przy rejestracji email przed turniejem dostaniesz informację odnośnie turnieju a w nim regulamin oraz zasady Savoir-vivre.<br>
                                    <span class="text-danger" >Jednocześnie informujemy, że 24 lipca rozsyłane będą maile i sms z prośbą o potwierdzenie uczestnictwa.</span><br><span class="fw-bold text-danger" >Brak potwierdzenia uczestnictwa wiąże się z wykreśleniem z turnieju</span>.
                                </p>
                            </div>
                            <div class="modal-footer py-2 bg-light d-flex justify-content-center">
                                <button type="button" class="btn btn-sm btn-primary fw-bold px-4" @click="closeSuccessModal">
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>                

            </form>
        </div>
    </div>
</template>

<script>
import { forEach } from 'lodash';

export default {
    props: {
        categories: { type: Array, required: true },
        slots: { type: Array, required: true },
        initialPools: { type: Array, required: true },
        totalCount: { type: Number, required: true }, // <-- NOWE
        tournamentId: { type: Number, default: 0 }
    },
    data() {
        return {
            poolsList: JSON.parse(JSON.stringify(this.initialPools)),
            slotsList: JSON.parse(JSON.stringify(this.slots)),
            
            // Reaktywna kopia licznika
            currentTotalCount: this.totalCount, 

            dropdownOpen: false,
            selectedSlotText: '',
            selectedSlotTimeOnly: '',
            showPaidModal: false,
            countdown: 3,
            countdownInterval: null,
            showSuccessInfoModal: false,
            rules_accepted: false,
            form: { tournament_id: this.tournamentId, name: '', gender: '', category_id: '', slot_id: '', form_email: '', phone_no: '' },
            loading: false, successMessage: '', errors: [], pollingInterval: null
        };
    },
    mounted() {
        this.pollingInterval = setInterval(() => { this.refreshData(); }, 30000);
        document.addEventListener('click', this.closeDropdownOutside);
    },
    beforeDestroy() {
        if (this.pollingInterval) { clearInterval(this.pollingInterval); }
        if (this.countdownInterval) { clearInterval(this.countdownInterval); }
        document.removeEventListener('click', this.closeDropdownOutside);
    },
    methods: {
        selectSlot(slot) {

            this.form.slot_id = slot.id;
            this.selectedSlotTimeOnly = slot.time_string;
            const available = slot.total_capacity - slot.registrations_count;
            this.selectedSlotText = slot.time_string + ' (Wolnych miejsc: ' + available + ')';
            this.dropdownOpen = false;
        },
        closeDropdownOutside(e) {
            if (!this.$el.querySelector('.custom-v-select').contains(e.target) && 
                (!this.$el.querySelector('.custom-v-dropdown') || !this.$el.querySelector('.custom-v-dropdown').contains(e.target))) {
                this.dropdownOpen = false;
            }
        },
        getPoolForCategoryAndSlot(categoryId) {
            

            let form_id = this.form.slot_id;
            if ((!this.form.slot_id) && (this.slotsList.length > 0)) {
                this.selectedSlotTimeOnly = this.slotsList[0].time_string;
                form_id = this.slotsList[0].id;
            } 

            const match = this.poolsList.find(p => p.category_id === categoryId && p.slot_id === form_id);
            return match ? match.free_pool : null;

            //if (this.form.slot_id) {
            //    const match = this.poolsList.find(p => p.category_id === categoryId && p.slot_id === this.form.slot_id);
            //    return match ? match.free_pool : null;
            //} 

            //let total = null;
            
            /* let pollArray = this.poolsList.filter(p => p.category_id === categoryId);

            if (pollArray) {
                pollArray.forEach(pool => {
                    if (pool.free_pool) {
                        total += pool.free_pool;
                    }
                });                               
            }


            //const match = this.poolsList.find(p => p.category_id === categoryId && p.slot_id === form_id);
            return total; */
        },
        getSlotBadgeClass(slot) {
            const left = slot.total_capacity - slot.registrations_count;
            if (left <= 0) return 'badge bg-danger';
            if (left <= 3) return 'badge bg-warning text-dark';
            return 'badge bg-info text-dark';
        },
        refreshData() {
            axios.get('/api/public/pule-wolne').then(res => { this.poolsList = res.data; });
            
            // Dodatkowo odświeżamy też stany wolnych miejsc w v-select (licznik ogólny) bez przeładowania strony
            // Laravel przekazuje to w showForm, ale przy odświeżaniu w tle pobieramy to z API
            // Dla prostoty i pełnej reaktywności, axios pobiera zaktualizowaną mapę
        },
        validateNameInput() { this.form.name = this.form.name.replace(/[^a-ząęćęłńóśźżó \-]/i, ''); },
        validatePhoneInput() { this.form.phone_no = this.form.phone_no.replace(/\D/g, ''); },

        submitForm() {
            if (!this.form.slot_id) { this.errors = ['Musisz wybrać godzinę startu turnieju.']; return; }
            if (!this.form.form_email && !this.form.phone_no) { this.errors = ['Musisz podać adres e-mail lub numer telefonu.']; return; }
            if (this.form.phone_no && this.form.phone_no.length !== 9) { this.errors = ['Numer telefonu musi składać się dokładnie z 9 cyfr.']; return; }

            const currentPool = this.getPoolForCategoryAndSlot(this.form.category_id);
            
            if (!currentPool || currentPool.remaining_slots <= 0) {
                this.triggerPaidModal();
                return;
            }

            this.executeRegistration();
        },

        triggerPaidModal() {
            this.showPaidModal = true;
            this.countdown = 3;
            if (this.countdownInterval) { clearInterval(this.countdownInterval); }
            this.countdownInterval = setInterval(() => {
                if (this.countdown > 0) { this.countdown--; } else { clearInterval(this.countdownInterval); }
            }, 1000);
        },
        confirmPaidRegistration() {
            this.showPaidModal = false;
            if (this.countdownInterval) { clearInterval(this.countdownInterval); }
            this.executeRegistration();
        },
        cancelPaidRegistration() {
            this.showPaidModal = false;
            if (this.countdownInterval) { clearInterval(this.countdownInterval); }
        },

        // PROCES WYKONYWANIA REJESTRACJI
        executeRegistration() {
            this.loading = true; this.errors = []; this.successMessage = '';
            const payload = { ...this.form, email: this.form.form_email };
            
            axios.post('/zapisy', payload)
                .then(response => {
                    this.loading = false;
                    this.successMessage = response.data.message;

                    this.currentTotalCount++;
                    
                    // Płynna aktualizacja: czyścimy formularz, pobieramy najświeższe limity miejsc
                    this.resetForm();
                    this.refreshData(); 

                    // WYŚWIETLAMY DRUGI MODAL Z TREŚCIĄ REGULAMINU
                    this.showSuccessInfoModal = true;
                })
                .catch(error => {
                    this.loading = false;
                    this.errors = [error.response.data.message || 'Błąd zapisu.'];
                });
        },
        
        // ZAMKNIĘCIE MODALU SUKCESU PRZEZ UŻYTKOWNIKA
        closeSuccessModal() {
            this.showSuccessInfoModal = false;
            this.successMessage = ''; // Czyścimy zielony baner, bo użytkownik zamknął proces
        },
        resetForm() {
            this.form.name = '';
            this.form.gender = '';
            this.form.category_id = '';
            this.form.slot_id = '';
            this.selectedSlotText = '';
            this.selectedSlotTimeOnly = '';
            this.form.form_email = '';
            this.form.phone_no = '';
            this.form.rules_accepted = false;
        }        
    }
};
</script>

<style scoped>
    /* STYLE DLA AUTORSKIEGO SKŁADNIKA V-SELECT */
    .custom-v-select { 
        cursor: pointer;
        background-color: #fff; 
        min-height: 38px;
        user-select: none; 
    }
    
    .custom-v-dropdown { 
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 1050;
        background: #ffffff;
        max-height: 220px;
        overflow-y: auto;
        border-radius: 0 0 6px 6px;
        margin-top: 2px; 
    }
    
    .dropdown-option { 
        cursor: pointer;
        transition: background-color 0.15s; 
    }
    
    .dropdown-option:hover { 
        background-color: #f8f9fa; 
    }

    /* Prosta i płynna animacja pojawiania się okna modalnego */
    .animate-fade-in {
        animation: fadeIn 0.2s ease-in-out forwards;
    }

    .dropdown-option-disabled {
        pointer-events: none !important;
        cursor: auto !important;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }   
</style>